(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nk-native-pack-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nk-native-pack-cards')) {
    customElements.define('nk-native-pack-cards', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.quantity = this.form?.querySelector('input[name="quantity"]');
        if (!this.quantity) return;
        this.onChoice = event => {
          if (!event.target.matches('input[type="radio"]') || event.target.disabled) return;
          this.quantity.value = event.target.value;
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.onQuantity = () => {
          for (const input of this.querySelectorAll('input[type="radio"]')) input.checked = input.value === this.quantity.value;
        };
        this.addEventListener('change', this.onChoice);
        this.quantity.addEventListener('change', this.onQuantity);
        this.closest('.product-form')?.classList.add('nk-native-pack-ready');
        this.onQuantity();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChoice);
        this.quantity?.removeEventListener('change', this.onQuantity);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nk-pack-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nk-pack-cards')) {
    customElements.define('nk-pack-cards', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-form');
        if (!this.root) return;
        this.observer = new MutationObserver(() => {
          if (this.pending) return;
          this.pending = true;
          queueMicrotask(() => { this.pending = false; this.decorate(); });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
        this.decorate();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      decorate() {
        const bars = [...this.root.querySelectorAll('.rapi-bundles__bars > .rapi-bundles__bar')];
        const base = Number(this.dataset.basePrice);
        const expected = [base, Math.round(base * 0.9), Math.round(base * 0.8)];
        if (bars.length !== 3 || !base) return;
        const matches = bars.every((bar, i) => {
          const price = bar.querySelector('.rapi-bundles__bar-price .money');
          return price && Number(price.textContent.replace(/\D/g, '')) === expected[i];
        });
        if (!matches) { this.root.classList.remove('nk-pack-cards-ready'); return; }
        const titles = [this.dataset.single, this.dataset.double, this.dataset.triple];
        bars.forEach((bar, index) => {
          const main = bar.querySelector('.rapi-bundles__bar-main');
          const label = bar.querySelector('.rapi-bundles__bar-container');
          const title = bar.querySelector('.rapi-bundles__bar-title span');
          if (!main || !label || !title) return;
          if (title.textContent !== titles[index]) title.textContent = titles[index];
          if (!main.querySelector('.nk-pack-cards__images')) {
            const pictures = document.createElement('div');
            pictures.className = 'nk-pack-cards__images';
            pictures.setAttribute('aria-hidden', 'true');
            for (let i = 0; i <= index; i++) {
              const picture = document.createElement('img');
              picture.src = this.dataset.image;
              picture.alt = '';
              picture.width = 80;
              picture.height = 80;
              picture.loading = 'lazy';
              picture.decoding = 'async';
              pictures.append(picture);
            }
            main.prepend(pictures);
          }
          if (index > 0 && !label.querySelector('.nk-pack-cards__badge')) {
            const badge = document.createElement('span');
            badge.className = 'nk-pack-cards__badge';
            badge.textContent = index === 1 ? '−10%' : '−20%';
            label.append(badge);
          }
          for (const price of bar.querySelectorAll('.rapi-bundles__bar-price, .rapi-bundles__bar-full-price')) {
            if (!price.querySelector('.nk-pack-cards__unit')) {
              const unit = document.createElement('span');
              unit.className = 'nk-pack-cards__unit';
              unit.textContent = ' / ' + this.dataset.unit;
              price.append(unit);
            }
          }
          const popular = bar.querySelector('.rapi-bundles__bar-most-popular__content span');
          if (popular && popular.textContent !== this.dataset.popular) popular.textContent = this.dataset.popular;
        });
        this.root.classList.add('nk-pack-cards-ready');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nk-product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nk-product-price')) {
    customElements.define('nk-product-price', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info') || this.parentElement;
        this.form = document.getElementById(this.dataset.formId);
        this.base = Number(this.dataset.basePrice);
        this.plans = JSON.parse(this.querySelector('[data-price-plans]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.amount = this.querySelector('[data-price-total]');
        this.unit = this.querySelector('[data-price-unit]');
        this.compare = this.querySelector('[data-price-compare]');
        this.label = this.querySelector('[data-price-label]');
        // Use the declared net contents, avoiding a second rounding of Shopify's unit price.
        const units = { mg: .001, g: 1, kg: 1000, ml: 1, cl: 10, l: 1000, mm: 1, cm: 10, m: 1000 };
        const quantityUnit = this.dataset.quantityUnit;
        const referenceUnit = this.dataset.referenceUnit;
        const quantity = Number(this.dataset.unitQuantity);
        const reference = Number(this.dataset.referenceValue);
        const conversion = quantityUnit === referenceUnit ? 1 : units[referenceUnit] / units[quantityUnit];
        this.unitRatio = quantity > 0 && reference > 0 && Number.isFinite(conversion)
          ? reference * conversion / quantity
          : this.base > 0 ? Number(this.dataset.unitPrice) / this.base : 0;
        this.onChange = () => queueMicrotask(() => { if (this.isConnected) this.update(); });
        this.onClick = event => { if (event.target.closest('.rapi-bundles__bar')) this.onChange(); };
        this.scope.addEventListener('change', this.onChange);
        this.scope.addEventListener('click', this.onClick);
        this.update();
      }
      formatMoney(cents) {
        const parts = this.money.formatToParts(cents / 100);
        if (this.dataset.currency === 'EUR') return '€' + parts.filter(part => part.type !== 'currency' && part.type !== 'literal').map(part => part.value).join('');
        return parts.map(part => part.value).join('');
      }
      update() {
        if (!this.form) return;
        const purchase = this.form.closest('.product-form');
        const nativePacks = purchase?.querySelector('nk-native-pack-cards');
        const rapiPacks = purchase?.querySelectorAll('.rapi-bundles__bars > .rapi-bundles__bar');
        const selectedPack = nativePacks?.querySelector('input:checked');
        const rawQuantity = Number(selectedPack?.value || this.form.querySelector('input[name="quantity"]')?.value || 1);
        const quantity = Number.isInteger(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
        const hasPackDiscount = Boolean(nativePacks) || rapiPacks?.length === 3;
        const factor = hasPackDiscount ? (quantity >= 3 ? .8 : quantity === 2 ? .9 : 1) : 1;
        const planInput = this.form.querySelector('input[name="selling_plan"]');
        const plan = planInput && !planInput.disabled ? this.plans.find(item => String(item.id) === planInput.value) : null;
        // Match the existing pack/subscription controls and Shopify's per-item rounding.
        const perItem = Math.round((plan ? Number(plan.price) : this.base) * factor);
        this.amount.textContent = this.formatMoney(perItem * quantity);
        if (this.unit) this.unit.textContent = this.formatMoney(Math.round(perItem * this.unitRatio));
        if (this.compare) this.compare.textContent = this.formatMoney(Number(this.dataset.comparePrice) * quantity);
        this.label.textContent = plan ? this.dataset.deliveryLabel : this.dataset.totalLabel;
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('change', this.onChange);
        this.scope?.removeEventListener('click', this.onClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nk-subscription-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nk-subscription-preview')) {
    customElements.define('nk-subscription-preview', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.root = this.closest('.product-form');
        if (!this.form || !this.root) return;
        this.base = Number(this.dataset.basePrice);
        this.plans = JSON.parse(this.querySelector('[data-selling-plans]').textContent);
        if (!this.plans.length) return;
        this.planInput = this.querySelector('[data-selling-plan-input]');
        this.maxQuantity = Number(this.dataset.maxSubscriptionQuantity);
        this.months = Number(this.dataset.months);
        this.fixedInterval = this.dataset.fixedInterval === 'true';
        this.money = new Intl.NumberFormat(this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.choice = this.querySelector('input[value="subscription"]');
        this.once = this.querySelector('input[value="once"]');
        this.interval = this.querySelector('select');
        this.submit = this.form.querySelector('button[type="submit"][name="add"]');
        this.quantity = this.readQuantity();
        this.onPackChoice = event => {
          const native = event.target.closest('nk-native-pack-cards input[type="radio"]');
          const rapi = event.target.closest('.rapi-bundles__bars > .rapi-bundles__bar');
          if (native && !native.disabled) this.quantity = Number(native.value);
          else if (rapi) {
            const bars = [...this.root.querySelectorAll('.rapi-bundles__bars > .rapi-bundles__bar')];
            const input = rapi.querySelector('input[type="radio"]');
            if (bars.length !== 3 || input?.disabled) return;
            this.quantity = bars.indexOf(rapi) + 1;
          } else if (event.target.matches('input[name="quantity"]')) this.quantity = Number(event.target.value);
          else return;
          this.update();
          this.setPurchaseState();
        };
        this.onMode = event => {
          if (!event.target.matches('input[type="radio"], select')) return;
          this.update();
          this.setPurchaseState();
        };
        this.guardSubscription = event => {
          this.syncSellingPlan();
          if (!this.choice.checked || this.subscriptionAvailable) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('.nk-abo__preview-note').scrollIntoView({ block: 'nearest' });
        };
        this.root.addEventListener('change', this.onPackChoice);
        this.root.addEventListener('click', this.onPackChoice);
        this.addEventListener('change', this.onMode);
        this.form.addEventListener('submit', this.guardSubscription, true);
        this.positionObserver = new MutationObserver(() => this.positionAfterPacks());
        this.positionObserver.observe(this.form, { childList: true });
        this.positionAfterPacks();
        this.update();
        this.setPurchaseState();
        this.hidden = false;
      }
      readQuantity() {
        const native = this.root.querySelector('nk-native-pack-cards input:checked');
        if (native) return Number(native.value);
        const bars = [...this.root.querySelectorAll('.rapi-bundles__bars > .rapi-bundles__bar')];
        const selected = bars.findIndex(bar => bar.querySelector('input:checked'));
        return selected >= 0 ? selected + 1 : Number(this.form.querySelector('input[name="quantity"]')?.value) || 1;
      }
      positionAfterPacks() {
        const buttons = this.form.querySelector('.product-form__buttons');
        if (buttons && this.nextElementSibling !== buttons) buttons.before(this);
      }
      update() {
        const quantity = Number.isInteger(this.quantity) && this.quantity > 0 ? this.quantity : 1;
        const factor = quantity >= 3 ? .8 : quantity === 2 ? .9 : 1;
        const packTotal = Math.round(this.base * factor) * quantity;
        const subscriptionTotal = Math.round(packTotal * .9);
        const oncePrice = this.money.format(packTotal / 100);
        this.querySelector('[data-once-price]').textContent = oncePrice;
        this.querySelector('[data-regular-price]').textContent = oncePrice;
        this.querySelector('[data-abo-price]').textContent = this.money.format(subscriptionTotal / 100);
        this.querySelector('[data-delivery-summary]').textContent = this.dataset.delivery.replace('[quantity]', String(quantity));
        if (this.months > 0) {
          const recommended = this.fixedInterval ? this.months : this.months * quantity;
          const previous = Number(this.interval.selectedOptions[0]?.dataset.months || this.interval.value);
          const durations = [recommended, recommended * 2];
          const availablePlans = durations.map(months => this.plans.find(plan => plan.months === months)).filter(Boolean);
          if (this.interval.dataset.quantity !== String(quantity)) {
            this.interval.replaceChildren(...availablePlans.map((plan, index) => {
              const months = plan.months;
              const option = document.createElement('option');
              option.value = String(plan.id);
              option.dataset.months = String(months);
              option.textContent = this.dataset.interval.replace('[months]', String(months)) + (index === 0 && !this.fixedInterval ? ' (' + this.dataset.recommended + ')' : '');
              return option;
            }));
            const selectedPlan = availablePlans.find(plan => plan.months === previous) || availablePlans[0];
            this.interval.value = selectedPlan ? String(selectedPlan.id) : '';
            this.interval.dataset.quantity = String(quantity);
          }
          this.querySelector('[data-supply-summary]').textContent = this.fixedInterval
            ? this.dataset.fixedIntervalNote
            : this.dataset.supply.replace('[months]', String(recommended));
        } else this.querySelector('[data-supply-summary]').textContent = this.dataset.unknown;
        const selectedPlan = this.plans.find(plan => String(plan.id) === this.interval.value);
        this.subscriptionAvailable = Boolean(selectedPlan) && quantity <= this.maxQuantity && this.dataset.productAvailable === 'true';
        this.choice.disabled = !this.subscriptionAvailable;
        this.interval.disabled = !this.subscriptionAvailable;
        this.querySelector('[data-abo-unavailable]').hidden = this.subscriptionAvailable;
        if (selectedPlan) this.querySelector('[data-abo-price]').textContent = this.money.format(Math.round(selectedPlan.price * factor) * quantity / 100);
        this.syncSellingPlan();
      }
      syncSellingPlan() {
        const selected = this.choice.checked && this.subscriptionAvailable;
        this.planInput.disabled = !selected;
        this.planInput.value = selected ? this.interval.value : '';
      }
      setPurchaseState() {
        const selected = this.choice.checked;
        this.form.classList.toggle('nk-abo-preview-selected', selected);
        this.syncSellingPlan();
        const shouldBlock = selected && !this.subscriptionAvailable;
        if (shouldBlock && this.submit && !this.disabledByPreview) {
          this.previousDisabled = this.submit.disabled;
          this.submit.disabled = true;
          this.disabledByPreview = true;
        } else if (!shouldBlock && this.disabledByPreview) {
          this.submit.disabled = this.previousDisabled;
          this.disabledByPreview = false;
        }
      }
      disconnectedCallback() {
        this.positionObserver?.disconnect();
        this.root?.removeEventListener('change', this.onPackChoice);
        this.root?.removeEventListener('click', this.onPackChoice);
        this.removeEventListener('change', this.onMode);
        this.form?.removeEventListener('submit', this.guardSubscription, true);
        if (this.disabledByPreview && this.submit) this.submit.disabled = this.previousDisabled;
        this.form?.classList.remove('nk-abo-preview-selected');
        if (this.planInput) this.planInput.disabled = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
